import { useId, useState, type InputHTMLAttributes, type ReactNode } from 'react';

import './checkbox.css';

export interface LovoCheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  children?: ReactNode;
}

export function Checkbox({
  children,
  id,
  className = '',
  checked,
  defaultChecked,
  onChange,
  ...props
}: LovoCheckboxProps) {
  const generatedId = useId();
  const inputId = id ?? generatedId;
  const [uncontrolledChecked, setUncontrolledChecked] = useState(Boolean(defaultChecked));
  const resolvedChecked = checked ?? uncontrolledChecked;

  return (
    <label className={['lovo-checkbox', className].filter(Boolean).join(' ')} htmlFor={inputId}>
      <input
        {...props}
        checked={checked}
        defaultChecked={checked === undefined ? defaultChecked : undefined}
        id={inputId}
        onChange={(event) => {
          if (checked === undefined) setUncontrolledChecked(event.target.checked);
          onChange?.(event);
        }}
        type="checkbox"
      />
      <span
        className="lovo-checkbox__control"
        data-figma-node={resolvedChecked ? '1:14005' : '1:14008'}
        data-figma-variant={`State=${resolvedChecked ? 'Filled' : 'Empty'}`}
        aria-hidden="true"
      >
        {resolvedChecked ? (
          <svg className="lovo-checkbox__icon" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="20" height="20" rx="4" fill="#84954D"/>
            <path d="M4.84233 10.7294L6.24432 9.32244L8.54616 11.5845L13.652 6.49858L15.0639 7.90554L8.54616 14.3885L4.84233 10.7294Z" fill="white"/>
          </svg>
        ) : null}
      </span>
      {children && <span className="lovo-checkbox__label">{children}</span>}
    </label>
  );
}
